import { StateManager } from '../stateManager';

import { SET_COMMENTS } from './actions';

export const initialState = {
  commentsList: {},
};

const setComments = (state, action) => {
  let { comments } = action;
  return { ...state, commentsList: comments };
};

const actions = {
  [SET_COMMENTS]: setComments,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
